define("Code25.CaterpartsGlobal.OpenOrders", ["underscore"], function (_) {
    "use strict";

    function addMenuItems(myAccountMenu) {
        var menuItems = [
            {
                id: "deliverycollectioninformation",
                groupid: "orders",
                name: _.translate("Outstanding Orders"),
                url: "open-purchases",
                index: "1",
            },
        ];
        _.each(menuItems, function (item) {
            myAccountMenu.addGroupEntry(item);
        });
    }

    return {
        mount: function mount (container){
            var myAccountMenu = container.getComponent("MyAccountMenu");
            //var pageType = container.getComponent("PageType");

            if (myAccountMenu) {
                addMenuItems(myAccountMenu);
            }
        },
    };
});
